// extracted by mini-css-extract-plugin
module.exports = {"s7pjti2":"s7pjti2","a8zdn83":"a8zdn83"};